export const plans = [
  {
    title: "Hot Discount Days",
    desc: "a magical journey of friendship, courage.",
    author: "Joanne Rowling",
    date: "2007 year",
    location: "Great Britain",
    img: "/img/harry.webp",
  },
  {
    title: "Coming Soon",
    desc: "✨ Explore introspection, ego, and self-discovery.",
    author: "Fotih Duman",
    date: "2000 year",
    location: "Turkey, Istambul",
    img: "/img/men.webp",
  },
  {
    title: "New Project Lunch",
    desc: "🐷 A classic allegorical novel exposing corruption.",
    author: "Orwell",
    date: "1943 year",
    location: "London",
    img: "/img/animall.webp",
  },
  {
    title: "Join us on sns",
    desc: "📚 A classic Uzbek novel exploring society, love.",
    author: "Abdulla Qodiriy",
    date: "1920 year",
    location: "Uzbekistan",
    img: "/img/Bygone_Days.webp",
  },
  {
    title: "Coming Soon",
    desc: "✨ Explore introspection, ego, and self-discovery.",
    author: "Fotih Duman",
    date: "2000 year",
    location: "Turkey, Istambul",
    img: "/img/men.webp",
  },
];
